import { catchRestError, RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";

export type B090SokoIdoRequest = {
  shohinCd: string;
  idosu: string;
} & Partial<{
  meisaibiko: string;
}>;

export type B090020CreateRequest = {
  idouYmd: string;
  shainCd: string;
  bumonCd: string;
  haraidashisokoCd: string;
  ukeiresokoCd: string;
} & Partial<{ soukoIdouList: B090SokoIdoRequest[] }>;

// 登録処理
export const B090020Create = (props: B090020CreateRequest) => {
  return RestClient.post("b090020/create", props);
};

export type B090020GetRequest = {
  shohinCd: string;
  haraidashisokoCd: string;
};

export const B090020GetHikiate = (props: B090020GetRequest) => {
  return RestClient.get("b090020/get/hikiate", {
    params: props,
  });
};

//可能数取得処理
export const B090020Kanosu = (
  methods: UseFormReturn,
  meiMethods: UseFormReturn,
  navigate: Function,
  setMsg: Function
) => {
  const data = methods.getValues();
  const meiData = meiMethods.getValues();
  if (meiData.shohinCd === "" || data.haraidashisokoCd === "") {
    meiMethods.setValue("kanosu", "");
    return;
  }
  B090020GetHikiate({
    shohinCd: meiData.shohinCd,
    haraidashisokoCd: data.haraidashisokoCd,
  })
    .then((response) => {
      meiMethods.setValue("kanosu", response.data.kanosu ?? "");
    })
    .catch((reason) => {
      catchRestError(reason, navigate, setMsg);
      meiMethods.setValue("kanosu", "");
    });
};
